import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import PropTypes from "prop-types";
import { getPaymentAndUserInfo } from "api/payment";
import { IndirectEval } from "helper/indirectEval";
import { setIsPaymentTransactionsFetching } from "redux/paymentReducer";
import moment from "moment";

const PaymentTransactionPreview = (props) => {
  const dispatch = useDispatch();
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);

  const [paymentTransactionsData, setPaymentTransactionsData] = useState([]);
  const [isFetchingPaymentTransactions, setIsFetchingPaymentTransactions] =
    useState(true);

  const findPaymentIdObject = (primaryUserInfo, paymentIdKey) => {
    return (
      Array.isArray(primaryUserInfo?.payment_ids) &&
      primaryUserInfo?.payment_ids?.length &&
      primaryUserInfo?.payment_ids?.find((item) =>
        item?.hasOwnProperty(paymentIdKey)
      )
    );
  };

  const fetchLabelName = (labelName) => {
    const label = props?.inputFields?.length
      ? props?.inputFields?.find(
          (item) => (item?.name || item?.id) === labelName
        )?.label || labelName
      : labelName;
    return titleCase(label);
  };

  useEffect(() => {
    const fetchPaymentTransactions = async (paymentModuleId) => {
      dispatch(setIsPaymentTransactionsFetching(true));
      const paymentIDObject = findPaymentIdObject(primaryUser, paymentModuleId);
      const paymentIdGEn = paymentIDObject?.[paymentModuleId];
      const paymentTransactions = await dispatch(
        getPaymentAndUserInfo({
          payment_id: paymentIdGEn,
          user_id: decryptedId?.userId,
        })
      ).unwrap();
      setPaymentTransactionsData(paymentTransactions?.payment_history || []);
      dispatch(setIsPaymentTransactionsFetching(false));
      setIsFetchingPaymentTransactions(false);
    };

    if (props.paymentModuleID) {
      fetchPaymentTransactions(props.paymentModuleID);
    }
  }, [props.paymentModuleID]);

  const titleCase = (s) =>
    s
      .toString()
      .replaceAll("_", " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const mapValues = (item, key = "") => {
    if (Array.isArray(item)) {
      return item.map((_item) => _item["value"]).join(",");
    } else if (typeof item === "object") {
      return item?.original_name;
    } else {
      if (key && props?.fields_to_be_date_formatted?.hasOwnProperty(key)) {
        return moment(item).format(props?.fields_to_be_date_formatted?.[key]);
      }
      return item;
    }
  };

  const shouldShowData = useMemo(() => {
    return (key, value, inputFields) => {
      if (!value) return false;
      const inputField = inputFields.find((item) => item.name === key)?.label;
      if (!inputField) return false;
      if (inputField?.show) {
        return IndirectEval(inputField?.show, props?.inputFields);
      }
      return true;
    };
  }, [props?.inputFields]);

  let paymentTransactions = null;
  if (paymentTransactionsData?.length) {
    paymentTransactions = paymentTransactionsData.map((item, index) => (
      <div
        className="preview"
        key={`preview-${index + 1}-${item.transaction_id}`}
      >
        {Object.entries(item).map(
          ([key, value], subIndex) =>
            shouldShowData(key, value, props.inputFields) && (
              <div
                className="preview_item"
                key={`preview_item-${index + 1}-${subIndex + 1}`}
              >
                <div className="col-12">
                  <span className="preview_item_label">
                    {fetchLabelName(key)}
                  </span>
                  <span className="preview_item_value">{mapValues(value,key)}</span>
                </div>
              </div>
            )
        )}
      </div>
    ));
  }

  return (
    <div className="form-container">
      {isFetchingPaymentTransactions ? (
        <div className="skeleton_loading_animation">
          <div className="skeleton_row"></div>
          <div className="skeleton_row"></div>
          <div className="skeleton_row"></div>
        </div>
      ) : (
        paymentTransactions
      )}
    </div>
  );
};

PaymentTransactionPreview.propTypes = {
  paymentModuleID: PropTypes.string.isRequired,
  inputFields: PropTypes.array,
  fields_to_be_date_formatted:PropTypes.object
};

export default PaymentTransactionPreview;
